<ng-container>
  <section class="list-wrapper madar--v2">
    <div class="tabs">
      <app-tab [theme]="'trapezoid'" [tabs]="tabs" [selectedIndex]="selectedIndex" (currentIndex)="getCurrentTabIndex($event)">
        <div class="bg-white px-2 pt-4 pb-3 radius-2 flex align-center justify-space-between wrap">
          <div class="flex align-center">
            <app-search-input
              [placeholder]="'Placeholder.ShipmentsSearch' | translate"
              class="col-auto"
              [searchKeyEnum]="ShipmentSearchFields"
              (searchValue)="onSearch($event)"
            ></app-search-input>
            <div class="text-400">
              <span class="small mr-1">{{ "TransportationPayments.TotalCount" | translate}}:</span>
              <span class="small">{{ selectedShipments.length }}</span>
            </div>
          </div>

          <div class="flex align-center">
            <button mat-button [disabled]="!selectedShipments.length" class="btn-primary small py-0" (click)="makeAPayment();">
              <span class="text-nowrap">{{ "Buttons.MakeAPayment" | translate}}</span>
            </button>
            <app-export-button (buttonClicked)="onExportClicked()"></app-export-button>
            <app-filter-button [isPrimaryLightColor]="true" [filterNavigationConfig]="filterNavigationConfig"></app-filter-button>
          </div>
        </div>
        <app-entity-listing
          [totalCount]="totalRowsCount"
          [state]="sectionState"
          [pageIndex]="pageIndex"
          [pageSize]="pageSize"
          [emptyStateMainLabel]="'TransportationPayments.EmptyStateMainLabel' | translate"
          [errorStateLabel]="'ErrorMessages.ErrorHappened' | translate"
          (pageIndexChanged)="onPageIndexChange($event)"
        >
          <table class="table scrollable scrollable--x scrollable--y" mat-table [dataSource]="dataSource" matSort>
            <ng-container matColumnDef="action">
              <th mat-header-cell *matHeaderCellDef>{{ "TransportationPayments.Action" | translate }}</th>
              <td mat-cell *matCellDef="let element">
                <mat-checkbox
                  color="primary"
                  *ngIf="((element.transportationPayment?.status === Status.PENDING && !element.transportationPayment?.invoiceTransportationPayment) || element.transportationPayment?.status === Status.REJECTED) && element.history[0]?.action === ShipmentAction.GoodsDelivered "
                  [checked]="element.selected"
                  (change)="markElement($event, element)"
                ></mat-checkbox>
              </td>
            </ng-container>

            <ng-container matColumnDef="id">
              <th mat-header-cell *matHeaderCellDef>{{ "TransportationPayments.ShipmentId" | translate }}</th>
              <td mat-cell *matCellDef="let element">{{ element.id }}</td>
            </ng-container>

            <ng-container matColumnDef="shipmentStatus">
              <th mat-header-cell *matHeaderCellDef>{{ "TransportationPayments.ShipmentStatus" | translate }}</th>
              <td mat-cell *matCellDef="let element">
                <app-rect-tag [color]="colorShipmentPerStatus[element.history[0]?.action]">
                  <span class="text-nowrap">{{ "Enum.ShipmentStatus." + element.history[0]?.action | translate }}</span>
                </app-rect-tag>
              </td>

              <td mat-cell *matCellDef="let element">{{ "Enum.ShipmentStatus." + element.history[0]?.action | translate }}</td>
            </ng-container>

            <ng-container matColumnDef="createdAt">
              <th mat-header-cell *matHeaderCellDef class="title-width">{{ "TransportationPayments.CreatedAt" | translate }}</th>
              <td mat-cell *matCellDef="let element">{{ (element.createdAt | date: 'dd LLL YYYY') || '_______' }}</td>
            </ng-container>

            <ng-container matColumnDef="deliveryNoteRef">
              <th mat-header-cell *matHeaderCellDef class="total-num-width">{{ "TransportationPayments.DeliveryNoteReference" | translate }}</th>
              <td mat-cell *matCellDef="let element">
                <ng-container *ngFor="let item of element.deliveryNote; let i = index">
                  {{ item.referenceNumber || '_______' }}
                  <span *ngIf="i < element.deliveryNote.length - 1">,</span>
                </ng-container>
              </td>
            </ng-container>

            <ng-container matColumnDef="customerName">
              <th mat-header-cell *matHeaderCellDef>{{ "TransportationPayments.CustomerName" | translate }}</th>
              <td mat-cell *matCellDef="let element">{{ element.customer.title || '_______' }}</td>
            </ng-container>

            <ng-container matColumnDef="from">
              <th mat-header-cell *matHeaderCellDef>{{ "TransportationPayments.From" | translate }}</th>
              <td mat-cell *matCellDef="let element">{{ element.pickUpLocation?.city?.name || '_______' }}</td>
            </ng-container>

            <ng-container matColumnDef="to">
              <th mat-header-cell *matHeaderCellDef>{{ "TransportationPayments.To" | translate }}</th>
              <td mat-cell *matCellDef="let element">{{ element.dropOffLocation?.city?.name || '_______' }}</td>
            </ng-container>

            <ng-container matColumnDef="truckNo">
              <th mat-header-cell *matHeaderCellDef>{{ "TransportationPayments.TruckNo" | translate }}</th>
              <td mat-cell *matCellDef="let element">{{ element.driver?.truck?.plateNumber || '_______' }}</td>
            </ng-container>

            <ng-container matColumnDef="tripCost">
              <th mat-header-cell *matHeaderCellDef>{{ "TransportationPayments.TripCost" | translate }}</th>
              <td mat-cell *matCellDef="let element">{{ element.fleetPrice?.toLocaleString() || '_______' }}</td>
            </ng-container>

            <ng-container matColumnDef="multiDis">
              <th mat-header-cell *matHeaderCellDef>{{ "TransportationPayments.MultiDis" | translate }}</th>
              <td mat-cell *matCellDef="let element">{{ element.multiDestinationChargeCost?.toLocaleString() || '_______' }}</td>
            </ng-container>

            <ng-container matColumnDef="waitingCharge">
              <th mat-header-cell *matHeaderCellDef>{{ "TransportationPayments.WaitingCharge" | translate }}</th>
              <td mat-cell *matCellDef="let element">{{ element.fleetWaitingCharge?.toLocaleString() || '_______' }}</td>
            </ng-container>

            <ng-container matColumnDef="fleetReturnCharge">
              <th mat-header-cell *matHeaderCellDef>{{ "TransportationPayments.ReturnCharge" | translate }}</th>
              <td mat-cell *matCellDef="let element">{{ element.fleetReturnCharge?.toLocaleString() || '_______' }}</td>
            </ng-container>

            <ng-container matColumnDef="fleetWeightingFine">
              <th mat-header-cell *matHeaderCellDef>{{ "TransportationPayments.WeightingFine" | translate }}</th>
              <td mat-cell *matCellDef="let element">{{ element.fleetWeightingFine?.toLocaleString() || '_______' }}</td>
            </ng-container>

            <ng-container matColumnDef="fleetClearanceFees">
              <th mat-header-cell *matHeaderCellDef>{{ "TransportationPayments.ClearanceFees" | translate }}</th>
              <td mat-cell *matCellDef="let element">{{ element.fleetClearanceFees?.toLocaleString() || '_______' }}</td>
            </ng-container>

            <ng-container matColumnDef="price">
              <th mat-header-cell *matHeaderCellDef>{{ "TransportationPayments.Price" | translate }}</th>
              <td mat-cell *matCellDef="let element">{{ element.customerPrice?.toLocaleString() || '_______' }}</td>
            </ng-container>

            <ng-container matColumnDef="total">
              <th mat-header-cell *matHeaderCellDef>{{ "TransportationPayments.Total" | translate }}</th>
              <td mat-cell *matCellDef="let element">{{ element.totalFleetCost?.toLocaleString() || '_______' }}</td>
            </ng-container>

            <ng-container matColumnDef="driverName">
              <th mat-header-cell *matHeaderCellDef>{{ "TransportationPayments.DriverName" | translate }}</th>
              <td mat-cell *matCellDef="let element">
                {{ element.driver ? (element.driver?.user?.firstName + ' ' + element.driver?.user?.lastName) : '_______' }}
              </td>
            </ng-container>

            <ng-container matColumnDef="iqamaId">
              <th mat-header-cell *matHeaderCellDef>{{ "TransportationPayments.IqamaId" | translate }}</th>
              <td mat-cell *matCellDef="let element">{{ element.driver?.iqamaId || '_______' }}</td>
            </ng-container>

            <ng-container matColumnDef="driverPhone">
              <th mat-header-cell *matHeaderCellDef>{{ "TransportationPayments.DriverPhone" | translate }}</th>
              <td mat-cell *matCellDef="let element">{{ element.driver?.user?.mobileNumber || '_______' }}</td>
            </ng-container>

            <ng-container matColumnDef="fleetType">
              <th mat-header-cell *matHeaderCellDef>{{ "TransportationPayments.FleetType" | translate }}</th>
              <td mat-cell *matCellDef="let element">{{ "Enum.FleetType." + element.type | translate }}</td>
            </ng-container>

            <ng-container matColumnDef="paymentStatus">
              <th mat-header-cell *matHeaderCellDef>{{ "TransportationPayments.PaymentStatus" | translate }}</th>

              <td mat-cell *matCellDef="let element">
                <app-rect-tag [color]="colorPerStatus[  element?.transportationPayment.status]">
                  <span class="text-nowrap">{{ 'Enum.TransportationPaymentsStatus.' + element?.transportationPayment.status | translate }}</span>
                </app-rect-tag>
              </td>
            </ng-container>

            <ng-container matColumnDef="paymentDate">
              <th mat-header-cell *matHeaderCellDef>{{ "TransportationPayments.PaymentDate" | translate }}</th>
              <td mat-cell *matCellDef="let element">
                {{ (element.transportationPayment?.invoiceTransportationPayment?.paid_at | date: 'dd LLL YYYY') || '_______' }}
              </td>
            </ng-container>

            <ng-container matColumnDef="bankRef">
              <th mat-header-cell *matHeaderCellDef>{{ "TransportationPayments.BankRef" | translate }}</th>
              <td mat-cell *matCellDef="let element">
                {{ element.transportationPayment?.invoiceTransportationPayment?.bankReference || '_______' }}
              </td>
            </ng-container>

            <ng-container matColumnDef="rejectionReason">
              <th mat-header-cell *matHeaderCellDef>{{ "TransportationPayments.RejectionReason" | translate }}</th>
              <td mat-cell *matCellDef="let element">
                {{ element.transportationPayment?.invoiceTransportationPayment?.rejectionReason || '_______' }}
              </td>
            </ng-container>

            <ng-container matColumnDef="assignedBy">
              <th mat-header-cell *matHeaderCellDef>{{ "TransportationPayments.CreatedBy" | translate }}</th>
              <td mat-cell *matCellDef="let element">
                {{ (element.createdBy?.firstName && element.createdBy?.lastName) ? element.createdBy?.firstName + ' ' + element.createdBy?.lastName :
                '_______' }}
              </td>
            </ng-container>

            <tr mat-header-row *matHeaderRowDef="displayedColumns"></tr>
            <tr mat-row *matRowDef="let row; columns: displayedColumns"></tr>
          </table>
        </app-entity-listing>
      </app-tab>
    </div>
  </section>
</ng-container>

<app-modal
  #paymentConfirmationModal
  [title]=" 'TransportationPayments.PaymentConfirmation' | translate "
  [maxWidth]="800"
  [padding]="20"
  [textColor]="'var(--color-on-surface-high-emphasis)'"
  [editCloseIcon]="true"
>
  <div *ngIf="paymentConfirmationModal.isModalOpened">
    <app-payment-confirmation-modal
      [selectedShipments]="selectedShipments"
      [startFrom]="startFrom ? startFrom : minimumStartDate"
      [endAt]="endAt ? endAt : maximumEndDate"
      (closeModal)="paymentConfirmationModal.closeModal()"
      (reloadComponent)="reloadComponent(); selectedShipments = [];"
    ></app-payment-confirmation-modal>
  </div>
</app-modal>
